import { render } from "./patients-grid-completed.vue?vue&type=template&id=b6b3f5ba"
const script = {}

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__